import React, { useState, useEffect } from "react";
import BlogDetailCard from "../../components/blog/detail/BlogDetailCard";
import CommentSection from "../../components/blog/detail/CommentSection";
import {
  makeStyles,
  Typography,
  Container,
  CircularProgress,
} from "@material-ui/core";
import { useParams } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  alignText: {
    marginTop: "5em",
    "& img": {
      display: "block",
      marginLeft: "auto",
      marginRight: "auto",
      width: "100%",
      maxWidth: "600px",
      objectFit: "cover",
      height: "100%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        maxWidth: "300px",
      },
    },
    "& p": {
      textAlign: "left",
    },
    "& a": {
      color: theme.palette.primary.main,
    },
    "& a:hover": {
      textDecoration: "underline",
    },
    "&": {
      color: theme.palette.secondary.main,
      fontFamily: theme.typography.fontFamily,
      fontWeight: "400",
      fontSize: "1rem",
    },
  },
  loading: {
    textAlign: "center",
    marginTop: "5em",
  },
}));

const BlogDetail = () => {
  const classes = useStyles();
  const { blogId } = useParams();
  const [blog, setBlog] = useState({});
  const [imageSrc, setImageSrc] = useState("");
  const [isLoad, setIsLoad] = useState(false);

  useEffect(() => {
    const getBlogUrl = `https://natakallam.com/wp-json/wp/v2/posts/${blogId}`;
    const getImgUrl = `https://natakallam.com/wp-json/wp/v2/media?parent=${blogId}`;

    fetch(getBlogUrl)
      .then((res) => res.json())
      .then((blog) => {
        setBlog(blog);
        setIsLoad(true);
      });

    fetch(getImgUrl)
      .then((resp) => resp.json())
      .then((img) => setImageSrc(img));
  }, [blogId]);
  if (isLoad) {
    return (
      <React.Fragment>
        <BlogDetailCard
          title={blog.title.rendered}
          image={imageSrc && imageSrc[0].source_url}
          authorId={blog.author}
        />
        <Container maxWidth="lg">
          <Container maxWidth="md">
            <Typography
              variant="subtitle1"
              className={classes.alignText}
              dangerouslySetInnerHTML={{ __html: blog.content.rendered }}
            ></Typography>
          </Container>

          <CommentSection blogId={blogId} />
        </Container>
      </React.Fragment>
    );
  }
  return (
    <Container className={classes.loading}>
      <CircularProgress />
    </Container>
  );
};

export default BlogDetail;
